import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { DeadlinesComponent } from './deadlines.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.REPORTS.DEADLINES' };
var routes = [
    {
        path: 'relatorios/prazos',
        component: DeadlinesComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var DeadlinesModule = /** @class */ (function () {
    function DeadlinesModule() {
    }
    return DeadlinesModule;
}());
export { DeadlinesModule };
export { ɵ0 };
